// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsFilePngSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 5a3 3 0 0 1 3-3h7.172a2 2 0 0 1 1.414.586l3.828 3.828A2 2 0 0 1 20 7.828V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zm9 3.5a.5.5 0 0 0 .5.5h3.293a.5.5 0 0 0 .353-.854l-3.292-3.292a.5.5 0 0 0-.854.353zm2.45 5.736h.705a.699.699 0 0 1-.118.332.696.696 0 0 1-.56.245c-.245 0-.442-.083-.582-.24a1.18 1.18 0 0 1-.297-.801c0-.59.363-1.033.853-1.033.332 0 .56.167.708.525l.814-.336c-.31-.635-.779-.928-1.483-.928-1.063 0-1.79.713-1.79 1.768 0 1.037.718 1.75 1.76 1.75.708 0 1.246-.333 1.518-.932.122-.263.166-.53.175-1.015H15.45zM7.859 15.4V14.3h.533c.394 0 .665-.096.85-.306.174-.192.266-.472.266-.8 0-.346-.11-.613-.32-.814-.214-.206-.441-.28-.826-.28H7V15.4zm.28-1.786h-.28v-.826h.284c.315 0 .468.14.468.415 0 .285-.144.411-.472.411zm1.77-1.513V15.4h.857v-2.017L12.34 15.4h.858v-3.3h-.858v2.018L10.765 12.1z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOperationsFilePngSolid;
